import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    const saved = window.localStorage.getItem("gwp_lang");
    if (saved && translations[saved]) return saved;
    return "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("gwp_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const change = useCallback((code) => {
    if (translations[code]) setLang(code);
  }, []);

  const t = translations[lang] || translations.de;

  return (
    <LanguageContext.Provider value={{ lang, change, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
};
